import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Configuration } from 'src/app/configuration';
import { IUser } from 'src/app/model/user';
import { ServiceBase } from '../service-base';
import { IUserData } from 'src/app/model/IUserData';
import { CookieService } from 'ngx-cookie-service';
import { CookiesLocalService } from '../cookies-local.service';

@Injectable({
      providedIn: 'root'
    })
    export class AuthService extends ServiceBase {

      constructor(http: HttpClient, cookieService: CookieService, cookieLocal: CookiesLocalService) { super(http, cookieService, cookieLocal); }

      isLoggedIn: boolean;



      redirectUrl: string;

      onInitPageLog() {
        const appName = 'UMES Admissions';
        const url = this.baseUrl + `/api/Util/InitLog?appName=${appName}`;
        return this.http.get<any[]>(url, this.getHttpHeaderOptionWithToken())
          .pipe(catchError(this.errorHandler));
      }

      getUserData(identificationId) {
        const loginTypeId = 4;
        const url = this.baseUrl + `/api/Account/GetUser?identificationId=${identificationId}&loginTypeId=${loginTypeId}`;
        return this.http.get<IUserData>(url, this.getHttpHeaderOptionWithToken())
        .pipe(catchError(this.errorHandler));

      }


      changeUserPassword(changePasswordData: any): any {
        const url = this.baseUrl + '/api/Account/ChangePassword';
        return this.http.post<any>(url, changePasswordData, this.getHttpHeaderOptionWithToken());
          }



      forgetPasswordSMS(studentNumber, indexNumber) {
        const url = this.baseUrl + `/api/MessagingService/ForgetPasswordSMS?studentNumber=${studentNumber}&indexNumber=${indexNumber}`;
        return this.http.get<any>(url, this.getHttpHeaderOptionWithNoAuth())
          .pipe(catchError(this.errorHandler));
    }

    forgetPasswordEmail(studentNumber, indexNumber) {
      const url = this.baseUrl + `/api/MessagingService/ForgetPasswordEmail?studentNumber=${studentNumber}&indexNumber=${indexNumber}`;
      return this.http.get<any>(url, this.getHttpHeaderOptionWithNoAuth())
        .pipe(catchError(this.errorHandler));
    }

      // storeToken(token: string) {
      //   // localStorage.setItem(Configuration.localStorageData.token,token);
      //   this.cookieLocal.getRefreshedUserToken(token);
      // }
      removeToken() {
        // return localStorage.removeItem(Configuration.localStorageData.token);
        return this.cookieLocal.removeUserToken();
      }
      getToken() {
        return this.cookieLocal.getUserToken();
      }


      public isAuthenticated(): boolean {
       return this.getToken() !== null;
     }


     ValidateUser(user: any) {
      return this.http.post(this.baseUrl + '/token',
      Configuration.getTokenUrl(user),
      this.getHttpHeaderOptionWithNoAuth())
    .pipe(
    map(userData => this.onSuccessLogin(userData)),
    catchError( this.errorHandler)
      );

    }

    onSuccessLogin(userCertificate: any) {
      this.storeToken(userCertificate.access_token);
      this.isLoggedIn = true;
      return userCertificate;
    }

    storeToken(token: string) {
      localStorage.setItem(Configuration.localStorageData.token, token);
    }

      getAuthorizationToken() {
        return this.cookieLocal.getUserToken();
      }

      logout() {
        // localStorage.removeItem(Configuration.localStorageData.applicaintData);
        localStorage.clear();
        this.cookieService.deleteAll('/');
        // this.cookieService.delete(Configuration.localStorageData.token);
        this.removeToken();
        this.isLoggedIn = false;
      }


    }
